// @ts-expect-error
import type {NetworkStatus} from 'react-apollo';

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSmsDripSequenceEditions as GetSmsDripSequenceEditionsQuery,
    GetSmsDripSequenceEditionsVariables as GetSmsDripSequenceEditionsQueryVariables,
    SmsDripEditionFragment as Edition,
} from 'nutshell-graphql-types';

import GET_SMS_DRIP_SEQUENCE_EDITIONS from '../queries/get-sms-drip-sequence-editions.graphql';

type Props = {
    dripSequenceId: string | null | undefined;
    limit: number;
    cursor?: string;
};

export function useGetSmsDripSequenceEditions(props: Props): {
    editions: Edition[];
    error: string | null | undefined;
    isLoading: boolean;
    refetch: () => Promise<any>;
    networkStatus: NetworkStatus;
} {
    const {
        data,
        loading: isLoading,
        error,
        refetch,
        networkStatus,
    } = useQuery<GetSmsDripSequenceEditionsQuery, GetSmsDripSequenceEditionsQueryVariables>(
        GET_SMS_DRIP_SEQUENCE_EDITIONS,
        {
            skip: !props.dripSequenceId,
            variables: {
                // @ts-expect-error
                dripSequenceId: props.dripSequenceId,
                limit: props.limit,
                cursor: props.cursor,
            },
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: true,
        }
    );

    const editionsData = data && data.smsDripSequence ? data.smsDripSequence.editions : null;

    const editions = editionsData
        ? editionsData.edges.map((edition) => {
              return edition.node;
          })
        : [];

    return {
        editions,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
        networkStatus,
    };
}
